/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-04 18:48:05
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2021-06-16 10:24:33
 * @Description:
 * @FilePath: /src/store/modules/user.js
 */
import {
    QZ_SPECIAL_TOKEN,
    QZ_TOKEN,
    QZ_PLATFORM_USER_OPEN_ID,
    QZ_PLATFORM_APP_ID,
    QZ_WX_OPEN_ID,
} from '@/lib/constant';
import store from '@/store';

const user = {
    state: {
        specialToken: false,
        token: null,
        userInfo: {},
        roles: null,
        platformUserOpenId: '',
        platformAppId: '',
        wxOpenId: '',
    },
    mutations: {
        setToken(state, data) {
            localStorage.setItem(store.getters.currentTokenKey, data);
            state.token = data;
            this.commit('reloadApp');
            // socket.start();
        },
        clearToken(state) {
            localStorage.removeItem(store.getters.currentTokenKey);
            state.token = null;
        },
        setSpecialToken(state, data) {
            localStorage.setItem(QZ_SPECIAL_TOKEN, data);
            state.specialToken = data;
        },
        setUserInfo(state, data) {
            state.userInfo = data;
        },
        setRoles(state, data) {
            state.roles = data;
        },
        setPlatformUserOpenId(state, data) {
            localStorage.setItem(QZ_PLATFORM_USER_OPEN_ID, data);
            state.platformUserOpenId = data;
        },
        setPlatformAppId(state, data) {
            localStorage.setItem(QZ_PLATFORM_APP_ID, data);
            state.platformAppId = data;
        },
        setWxOpenId(state, data) {
            localStorage.setItem(QZ_WX_OPEN_ID, data);
            state.wxOpenId = data;
        },
    },
    getters: {
        specialToken(state) {
            return state.specialToken;
        },
        currentTokenKey(state) {
            return state.specialToken ? `${store.getters.platformId}_${QZ_TOKEN}` : QZ_TOKEN;
        },
    },
};

export default user;
